export const URL_START = '/start-interview/comparison2';
export const DEFAULT_LOCALE = 'en';
export const INTERVIEW_TYPE = 'comparison-new';



// WEBPACK FOOTER //
// ./src/comparison-new/constants.js